import { NostrEvent } from "nostr-tools";
import { getNutzapAmount } from "applesauce-wallet/helpers";

import { totalZaps } from "../helpers/nostr/zaps";
import useEventZaps from "./use-event-zaps";
import useEventNutzaps from "./use-event-nutzaps";

export default function useEventTipInfo(event: NostrEvent): { total: number; latestTipTime: number } {
  const zaps = useEventZaps(event) ?? [];
  const nutzaps = useEventNutzaps(event);

  const zapTotal = totalZaps(zaps);
  const nutzapTotal = nutzaps.reduce((sum, n) => sum + (getNutzapAmount(n) ?? 0), 0) * 1000;
  const total = zapTotal + nutzapTotal;

  let latestTipTime = 0;
  for (const z of zaps) {
    if (z.created_at > latestTipTime) latestTipTime = z.created_at;
  }
  for (const n of nutzaps) {
    if (n.created_at > latestTipTime) latestTipTime = n.created_at;
  }

  return { total, latestTipTime };
}
